export default function PaymentHistory() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Payment History
            </div>
            <div className="page-sub" id="page-sub">
              All your transactions
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="card">
            <div className="card-title">
              Payment History — Priya Sharma, Room 204
            </div>
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>For</th>
                  <th>Amount</th>
                  <th>Mode</th>
                  <th>UTR</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="sn-col">1</td>
                  <td>Apr 17</td>
                  <td>April 2025 Rent</td>
                  <td>₹9,660</td>
                  <td>UPI</td>
                  <td className="sn-col">UTR123456789</td>
                  <td>
                    <span className="badge badge-pending">Pending</span>
                  </td>
                </tr>
                <tr>
                  <td className="sn-col">2</td>
                  <td>Mar 15</td>
                  <td>March 2025 Rent</td>
                  <td>₹9,660</td>
                  <td>UPI</td>
                  <td className="sn-col">UTR000111222</td>
                  <td>
                    <span className="badge badge-active">Approved</span>
                  </td>
                </tr>
                <tr>
                  <td className="sn-col">3</td>
                  <td>Feb 12</td>
                  <td>February 2025 Rent</td>
                  <td>₹9,660</td>
                  <td>Bank Transfer</td>
                  <td className="sn-col">UTR888999000</td>
                  <td>
                    <span className="badge badge-active">Approved</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
